export function getQuestionId(question) {
  return question?.question_id || question?.id;
}

export function isSubQuestion(question) {
  return (
    question?.is_subquestion === true ||
    question?.is_subquestion === "true" ||
    question?.is_subquestion === 1 ||
    question?.is_subquestion === "1"
  );
}

function getSortNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 999999;
}

export function sortQuestionsForExam(questions = []) {
  return [...questions].sort((a, b) => {
    const partCompare =
      getSortNumber(a.part_display_order ?? a.part_order ?? a.part_id) -
      getSortNumber(b.part_display_order ?? b.part_order ?? b.part_id);

    if (partCompare !== 0) return partCompare;

    const sectionCompare =
      getSortNumber(a.section_display_order ?? a.section_order ?? a.section_id) -
      getSortNumber(b.section_display_order ?? b.section_order ?? b.section_id);

    if (sectionCompare !== 0) return sectionCompare;

    const questionNumberCompare =
      getSortNumber(a.question_number) - getSortNumber(b.question_number);

    if (questionNumberCompare !== 0) return questionNumberCompare;

    return (
      getSortNumber(a.assessment_question_id ?? getQuestionId(a)) -
      getSortNumber(b.assessment_question_id ?? getQuestionId(b))
    );
  });
}

export function getMainQuestions(questions = []) {
  return questions.filter((question) => !isSubQuestion(question));
}

export function getSubQuestionMap(questions = []) {
  return questions.reduce((map, question) => {
    if (isSubQuestion(question)) {
      map[String(getQuestionId(question))] = question;
    }

    return map;
  }, {});
}

export function groupQuestionsByPartAndSection(mainQuestions = []) {
  const groups = [];

  mainQuestions.forEach((question) => {
    const partKey = question.part_id || "no-part";
    const sectionKey = question.section_id || "no-section";

    let partGroup = groups.find((group) => String(group.partKey) === String(partKey));

    if (!partGroup) {
      partGroup = {
        partKey,
        partName: question.part_name || "",
        partInstruction: question.part_instruction || "",
        sections: [],
      };

      groups.push(partGroup);
    }

    let sectionGroup = partGroup.sections.find(
      (section) => String(section.sectionKey) === String(sectionKey)
    );

    if (!sectionGroup) {
      sectionGroup = {
        sectionKey,
        sectionName: question.section_name || question.section_title || "",
        sectionInstruction: question.section_instruction || "",
        questions: [],
      };

      partGroup.sections.push(sectionGroup);
    }

    sectionGroup.questions.push(question);
  });

  groups.sort((a, b) => getSortNumber(a.partKey) - getSortNumber(b.partKey));

  groups.forEach((part) => {
    part.sections.sort(
      (a, b) => getSortNumber(a.sectionKey) - getSortNumber(b.sectionKey)
    );
  });

  return groups;
}

export function groupQuestionsByPassage(questions = []) {
  const groups = [];

  questions.forEach((question) => {
    if (!question.passage_id) {
      groups.push({
        passage_id: null,
        passage_content: "",
        questions: [question],
      });

      return;
    }

    const existingGroup = groups.find(
      (group) =>
        String(group.passage_id) === String(question.passage_id)
    );

    if (existingGroup) {
      existingGroup.questions.push(question);
      return;
    }

    groups.push({
      passage_id: question.passage_id,
      passage_content: question.passage_content || "",
      questions: [question],
    });
  });

  return groups;
}